import React from "react";

export default function () {
    return (
        <React.Fragment>
            <p>&nbsp;</p>
            <h1>Welcome to The Write Class&trade;!</h1>
            <p>
                The Write Class&trade; is an online first-year writing course
                placement tool that integrates various points of data to create
                a personalized course placement for each student. It integrates
                and analyzes each student's
            </p>
            <ul>
                <li>high school GPA (if applicable);</li>
                <li>writing and reading history;</li>
                <li>preparedness for each course.</li>
            </ul>

            <p>
                It does not allow for multiple attempts, and placement results
                are final. Based on the information you provide in THE WRITE
                CLASS&trade;, you will be given a placement into one of three
                writing placement groups. From there, you will be presented with
                course options and information about each course and will be
                given the opportunity to decide which initial college writing
                course best fits your needs.
            </p>
            <p>
                This process will take between 30-40 minutes. Please be sure you
                have the time to answer all questions before beginning.
            </p>

            <h3>Honor Code Agreement</h3>
            <p>
                As a member of the Yakima Valley College community, you are
                obligated to abide by Yakima Valley College’s{" "}
                <a
                    href="https://www.yvcc.edu/students/code-of-conduct/"
                    target="_blank"
                    rel="noreferrer"
                >
                    Student Conduct Policy
                </a>{" "}
            </p>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/yvcc/siteComponents/auth.js